export default __webpack_public_path__ + "static/media/13.50195a97.jpg";